var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNote = function SvgNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.932 2c.402 0 .737.335.737.737v1.137c-.246-.03-.472-.059-.737-.059h-.737V5.08c0 .403.334.737.737.737a.743.743 0 0 0 .737-.737V3.874c2.9.266 4.178 2.134 4.178 4.856v8.355c0 2.948-1.476 4.915-4.915 4.915H8.068c-3.44 0-4.915-1.966-4.915-4.915V8.73c0-2.722 1.279-4.59 4.178-4.856V5.08c0 .403.334.737.737.737a.74.74 0 0 0 .737-.737V3.815h6.39V2.737c0-.402.334-.737.737-.737M7.556 14.782a.53.53 0 0 0 0 1.062h4.99a.532.532 0 0 0 0-1.062zm0-3.844a.53.53 0 0 0 0 1.062h8.63a.531.531 0 0 0 0-1.062zM8.068 2c.403 0 .736.335.737.737v1.078h-.737c-.265 0-.491.03-.737.059V2.737c0-.402.335-.737.737-.737"
  })));
};
export default SvgNote;